import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import reportWebVitals from './reportWebVitals';
import CB from './components/chatbot1'; 
import CB2 from './components/chatbot2';
import FAQ from './components/faq';     
import { initialize } from 'react-ga';

const App = () => {
  return (
    <Switch>
      <Route path="/chatbot" >
        <CB />
      </Route >
      <Route path="/chatbot2">
        <CB2 />
      </Route>
      <Route path="/">
        <FAQ />
      </Route>
      
    </Switch>
  );
};

ReactDOM.render(
  <Router>
    <App />
  </Router>,
  document.getElementById('root')
);

// Google Analytics Initialization
reportWebVitals();
initialize('G-VR4TP3NR5E');